import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const deleteSecondHandSupplyByPkMutation = gql`mutation delete_second_hand_supplies_by_pk($id: uuid!){
  delete_second_hand_supplies_by_pk(id: $id){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class DeleteSecondHandSupplyService {
/* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }

  /* ----------------------- Delete Second Hand Supply By Pk ----------------------- */
  deleteSecondHandSupplyByPk(id: string){
    return this.apollo.use('external').mutate({
      mutation: deleteSecondHandSupplyByPkMutation,
      variables:{
        id
      }
    }).toPromise();
  }
}
